import {useQuery} from '@apollo/client';
import {REVIEW_PAGE_QUERY} from './reviewPageQueries';
import {transformReviewsData} from './helpers';
import {GetReviewPage, GetReviewPageVariables} from '../../schema-types/GetReviewPage';
import {UUID} from '../../graphql/uuid';

export function useGetReviewPage(staffId: UUID) {
  const {data, loading, error, refetch} = useQuery<GetReviewPage, GetReviewPageVariables>(
    REVIEW_PAGE_QUERY,
    {
      variables: {staffId, curoSync: false},
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    }
  );

  const staffReviews = data?.staffReviews || [];

  const reviewsWithStages = transformReviewsData(staffReviews);

  return {
    refetch,
    data: reviewsWithStages,
    loading,
    error,
  };
}

// const transformedDummyData = {
//   CLOSED: [
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Macintosh, Jonathan & Sara',
//       },
//       dateScheduled: '2019-05-31T23:00:00+00:00',
//       name: 'Tosh Test',
//       reviewStatus: 'CLOSED',
//     },
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Macintosh, Jonathan & Sara',
//       },
//       reviewStatus: 'CLOSED',
//       name: 'XO - XO Withdrawal for £2k from GIA',
//     },
//   ],
//   OPEN: [
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Smith, Jane & John',
//       },
//       dateScheduled: '2019-05-31T23:00:00+00:00',
//       reviewStatus: 'OPEN',
//       name: 'Smith Portfolio Review',
//     },
//   ],
//   COMPLETED: [
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Doe, John',
//       },
//       reviewStatus: 'COMPLETED',
//       name: 'Annual Financial Review',
//     },
//   ],
//   SOFT_SUBMITTED: [
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Johnson, Anna',
//       },
//       reviewStatus: 'SOFT_SUBMITTED',
//       name: 'Investment Strategy Proposal',
//     },
//   ],
//   PLANNED: [
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Williams, Mark',
//       },
//       reviewStatus: 'PLANNED',
//       name: 'Q3 Portfolio Adjustment Plan',
//       dateScheduled: '2019-05-31T23:00:00+00:00',
//     },
//   ],
//   MEETING_BOOKED: [
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Brown, Catherine',
//       },
//       reviewStatus: 'MEETING_BOOKED',
//       name: 'Pre-retirement Financial Checkup',
//       dateBooked: '2020-08-19T23:00:00+00:00',
//     },
//   ],
//   AWAITING_EHONS: [
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Davis, Emily',
//       },
//       reviewStatus: 'AWAITING_EHONS',
//       name: 'Estate Planning Discussion',
//     },
//   ],
//   ERROR: [
//     {
//       __typename: 'ReviewType',
//       account: {
//         __typename: 'AccountType',
//         name: 'Garcia, Luis & Maria',
//       },
//       reviewStatus: 'ERROR',
//       name: 'Error in Application Process',
//     },
//   ],
// };
